import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../Home/Home";
import Greetings from "../Body/Company/Greetings";
import History from "../Body/Company/History";
import Location from "../Body/Company/Location";
import Contact from "../Body/Customer/Contact";
import Recruit from "../Body/Recruit/Recruit";
import Notice from "../Body/Customer/Notice";
import LoginPage from "../Login/LoginPage";
import Dashboard from "../Dashboard/Dashboard";
import EditPohotoPage from "../../Components/Dashboard/PhotoDashboard/EditPhotoPage";

const Router = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Home />}></Route>
      <Route path="/company/greeting" element={<Greetings />}></Route>
      <Route path="/company/history" element={<History />}></Route>
      <Route path="/company/location" element={<Location />}></Route>
      <Route path="/support/contact" element={<Contact />}></Route>
      <Route path="/support/notice" element={<Notice />}></Route>
      <Route path="/recruit" element={<Recruit />}></Route>
      <Route path="*" element={<Navigate to="/" replace />} />
      {/* <Route exact path="/Admin/Login" element={<LoginPage />}></Route>
      <Route path="/Admin/Dashboard" element={<Dashboard />}></Route>
      <Route
        path="/Admin/Dashboard/edit/:postId"
        element={<EditPohotoPage />}
      ></Route> */}
    </Routes>
  );
};
export default Router;
